import { createContext, useState, ReactNode } from "react";
import { OperatorsRegistrationContextProps, OperatorsRegistrationProviderProps, NewOperatorFormData } from "../../interfaces/Operators.interfaces";
import api from "../../services/api";

export const OperatorsRegistrationContext = createContext({} as OperatorsRegistrationContextProps);

export const OperatorsRegistrationProvider = ({ children }: OperatorsRegistrationProviderProps) => {
    const [modal, setModal] = useState<ReactNode>("");
    const modalState = { modal, setModal };

    function insertNewOperator(data: NewOperatorFormData) {
        const { NOME, LOGIN, SENHA, EMAIL, NIVEL,SETOR } = data;

        api.post('operators', { NOME, LOGIN, SENHA, EMAIL, NIVEL, SETOR})
            .then(res => {
              
            })
            .catch(err => console.error(err));
    };

    return (
        <OperatorsRegistrationContext.Provider value={{
            insertNewOperator,
            modalState
        }}>
            {children}
        </OperatorsRegistrationContext.Provider>
    );
};